<wms-dialog id="wm-oAuth-dialog" [content]="oAuthDialog" customClasses="oauth-provider-dialog medium wm-studio-dialog">
</wms-dialog>
<ng-template #oAuthDialog>
    <wms-dialog-header title="{{locale.LABEL_WEB_SERVICE_ADD_OAUTH_PROVIDER_TITLE}}" (onClose)="closeOAuthDialog()" helpLink="_blank" helpTitle="{{'oAuth'}}"></wms-dialog-header>
    <wms-dialog-body class="scrollable-container">
      <wms-message *ngIf="oauthProviderConfigMessage" [scopeDataset]="oauthProviderConfigMessage"></wms-message>
    <div class="oauth-prop-container">
        <div [hidden]="!apiService.activeProvider">
            <div class="col-sm-12 form-group app-composite-widget clearfix">
                <label class="col-sm-3 app-label control-label required">{{locale.LABEL_WEB_SERVICE_ADD_OAUTH_PROVIDER_ID}}</label>   
                <input placeholder="{{locale.PLACEHOLDER_ENTER_PROVIDER_ID}}" readonly="isPreDefinedProvider" [(ngModel)]="apiService.activeProvider.providerId" (onChange)="changeCallbackURL()" class="col-sm-9 app-text form-control wide-input" type="text">
            </div>
            <div class="col-sm-12 form-group app-composite-widget clearfix">
                <label class="col-sm-3 app-label control-label required">{{locale.LABEL_CALLBACK_URL}}</label>
                <div class="col-sm-9">
                    <div class="col-sm-12">
                        <div class="col-sm-12" (mouseover)="copyMsg = locale.ICONTITLE_COPY_CLIPBOARD">
                            <input id="provider-callback-url" [(ngModel)]="callbackURL" class="col-sm-10 form-control app-text wide-input" readonly="true" >
                            <button class="btn btn-transparent" tooltip="{{copyMsg}}"  placement="right" [tooltipAppendToBody]="true" (click)="copyURLToClipboard()">     <span>
                                <i class="wm-icon fa fa-copy"></i>
                            </span>
                        </button>
                        </div>
                        <small>{{locale.MESSAGE_WEB_SERVICE_SET_CALLBACK_URL}}</small>
                   </div>
                </div>
              </div>
            <div class="col-sm-12 form-group app-composite-widget clearfix">
              <label class="col-sm-3 app-label control-label required">{{locale.LABEL_FLOW}}</label>
              <select class="col-sm-9 app-text form-control wide-input" [(ngModel)]="apiService.activeProvider.oauth2Flow" [disabled]="isPreDefinedProvider" (onChange)="onFlowChange();" readonly="isPreDefinedProvider" >
                <option *ngFor="let method of flow_options" value="{{method.value}}">{{method.key}}
                </option>
              </select>
            </div>
            <div class="col-sm-4 form-group app-composite-widget clearfix" *ngIf="!implicitFlow">
              <label class="col-sm-9 app-label control-label">{{locale.LABEL_PKCE_SUPPORTED}}</label>
              <input type="checkbox" [(ngModel)]="apiService.activeProvider.oAuth2Pkce.enabled" (change)="onFlowChange();">
              <i placement="right" tooltip="{{locale.LABEL_HELP_PKCE_MSG}}" class="wm-icon wms wms-help" [tooltipAppendToBody]="true"></i>
            </div>
            <div class="col-sm-8 form-group app-composite-widget clearfix" *ngIf="!implicitFlow && apiService.activeProvider.oAuth2Pkce.enabled">
              <label class="col-sm-4 app-label control-label required">{{locale.LABEL_CODE_CHALLENGE_METHOD}}</label>
              <select class="col-sm-9 app-text form-control narrow-input" [(ngModel)]="apiService.activeProvider.oAuth2Pkce.challengeMethod">
                <option *ngFor="let method of challenge_options" value="{{method.value}}">{{method.key}}
                </option>
              </select>
              <i placement="right" tooltip="{{locale.LABEL_HELP_PKCE_CODE_CHALLENGE_MSG}}" class="wm-icon wms wms-help top-5" [tooltipAppendToBody]="true"></i>
            </div>
            <div class="col-sm-12 form-group app-composite-widget clearfix">
              <label class="col-sm-3 app-label control-label required">{{locale.LABEL_AUTHORIZATION_URL}}</label>
              <input placeholder="{{locale.PLACEHOLDER_AUTHORIZATION_URL}}" [(ngModel)]="apiService.activeProvider.authorizationUrl" class="col-sm-9 app-text form-control wide-input" type="text">
            </div>
          <div class="col-sm-12 form-group app-composite-widget clearfix" *ngIf="!implicitFlow">
              <label class="col-sm-3 app-label control-label required">{{locale.LABEL_ACCESS_TOKEN_URL}}</label>
              <input placeholder="{{locale.PLACEHOLDER_ACCESS_TOKEN_URL}}" [(ngModel)]="apiService.activeProvider.accessTokenUrl" class="col-sm-9 app-text form-control wide-input"
              type="text">
          </div>
          <div class="col-sm-12 form-group app-composite-widget clearfix">
              <label class="col-sm-3 app-label control-label required">{{locale.LABEL_CLIENT_ID}}</label>
              <input placeholder="{{locale.PLACEHOLDER_CLIENT_ID}}" [(ngModel)]="apiService.activeProvider.clientId" class="col-sm-9 app-text form-control wide-input" type="text">  </div>
              <div class="col-sm-12 form-group app-composite-widget clearfix" *ngIf="!implicitFlow && !apiService.activeProvider.oAuth2Pkce.enabled">  <label class="col-sm-3 app-label control-label required">{{locale.LABEL_CLIENT_SECRET}}</label>
                <input placeholder="{{locale.PLACEHOLDER_CLIENT_SECRET}}" [(ngModel)]="apiService.activeProvider.clientSecret" class="col-sm-9 app-text form-control wide-input"
                type="text">
          </div>
          <div class="col-sm-12 form-group app-composite-widget clearfix">
            <label class="col-sm-3 app-label control-label required">{{locale.LABEL_WEB_SERVICE_OAUTH_ACCESS_TOKEN}}</label>
            <select  class="col-sm-9 app-text form-control wide-input" [(ngModel)]="apiService.activeProvider.sendAccessTokenAs" (change)="onSetAccessTokenChange();">
                <option *ngFor="let method of accesstoken_options" value="{{method.value}}">{{method.key}}
                </option>
            </select>
          </div>
          <div class="col-sm-12 form-group app-composite-widget clearfix" *ngIf="implicitFlow">
            <label class="col-sm-3 app-label control-label required">{{locale.LABEL_WEB_SERVICE_RESPONSE_TYPE}}</label>
            <select class="col-sm-9 app-text form-control wide-input" [(ngModel)]="apiService.activeProvider.responseType">
                <option *ngFor="let type of responsetype_options" value="{{type.value}}">{{type.key}}
                </option>
            </select>
          </div>
          <div class="col-sm-12 form-group app-composite-widget clearfix">
            <label class="col-sm-3 app-label control-label">{{locale.LABEL_SCOPE}}</label>
            <div class="col-sm-6">
                <div class="col-sm-12">
                    <div>
                        <ul class="app-checkboxset">
                            <li class="app-checkbox" *ngFor="let scope of apiService.activeProvider.scopes">
                                <input type="checkbox"
                                       [ngModel]="apiService.activeProvider.scopeMap && apiService.activeProvider.scopeMap[scope.name]" (ngModelChange)="apiService.activeProvider.scopeMap && (apiService.activeProvider.scopeMap[scope.name] = $event)">
                                <label title="{{scope.value}}">{{scope.name}}</label><br>
                        </ul>
                    </div>
                    <div>
                        <table class="table">
                            <thead>
                            <tr>
                                <th>{{locale.LABEL_SCOPE_KEY}}</th>
                                <th>{{locale.LABEL_SCOPE_VALUE}}</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><input class="app-text form-control" type="text" placeholder="{{locale.LABEL_ENTER_KEY}}" [(ngModel)]="customScope.key"></td>
                                <td><input class="app-text form-control" placeholder="{{locale.LABEL_ENTER_VALUE}}" type="text" [(ngModel)]="customScope.value"></td> 
                                <td><button class="btn btn-primary" (click)="addScope(apiService.activeProvider);">{{locale.LABEL_ADD}}</button></td> 
                            </tr>
                            </tbody>
                         </table>
                     </div>
                 </div>
             </div>
          </div>
        </div>
    </div>
    </wms-dialog-body>
    <wms-dialog-footer>
      <button name="wm-oAuth-cancel" (click)="closeOAuthDialog()" class="btn button-secondary">{{locale.LABEL_CANCEL}}</button>
      <button name="wm-oAuth-save" class="btn button-primary" (click)="saveoAuthConfig($event)">{{locale.LABEL_SAVE}}</button>
    </wms-dialog-footer>
</ng-template>





